import React from "react";
import { Link } from "react-router-dom";
import { getBrandLogos } from "../../helpers/brandPortal";

type Props = {
  /** Destino do clique no logo (home tenant ou dashboard SA). */
  to?: string;
  /** Altura dos wordmarks grandes (auth costuma 20; shell 28). */
  heightLg?: number;
  heightSm?: number;
  className?: string;
};

/**
 * Wordmark dark/light + ícone sm — troca Br Envio ↔ Br Send pelo Host.
 */
const BrandLogoLinks = ({
  to = "/",
  heightLg = 28,
  heightSm = 28,
  className = "navbar-brand-box horizontal-logo",
}: Props) => {
  const logos = getBrandLogos();

  return (
    <div className={className}>
      <Link to={to} className="logo logo-dark">
        <span className="logo-sm">
          <img src={logos.sm} alt={logos.alt} height={heightSm} />
        </span>
        <span className="logo-lg">
          <img src={logos.dark} alt={logos.alt} height={heightLg} />
        </span>
      </Link>
      <Link to={to} className="logo logo-light">
        <span className="logo-sm">
          <img src={logos.sm} alt={logos.alt} height={heightSm} />
        </span>
        <span className="logo-lg">
          <img src={logos.light} alt={logos.alt} height={heightLg} />
        </span>
      </Link>
    </div>
  );
};

export default BrandLogoLinks;
